import { DataOptions, getDefault } from './DataOptions';

export interface SearchParams {
  dataOption: DataOptions;
  orClauseFieldsIds: string[];
  andClauseFieldsIds: string[]; // for chips search
  filter: string;
  view?: string;
}

export const SearchParamsEmpty: SearchParams = {
  dataOption: { ...getDefault },
  orClauseFieldsIds: [],
  andClauseFieldsIds: [],
  filter: '',
};
